import { size } from 'lodash'

import helpers from 'helpers'

import cnpj from './cnpj'
import cpf from './cpf'

const identify = (document = '', mask = false) => {
  if (!document) return ''

  const clearedDocument =
    helpers.formatters.regex.onlyNumbersAndLetters(document)

  if (mask) {
    return size(clearedDocument) > 11 ||
      helpers.formatters.regex.hasLetters(clearedDocument)
      ? cnpj(clearedDocument)
      : cpf(clearedDocument)
  }

  if (helpers.validates.cnpj.isValid(clearedDocument)) {
    return cnpj(clearedDocument)
  }

  if (helpers.validates.cpf.isValid(clearedDocument)) {
    return cpf(clearedDocument)
  }

  return document
}

const document = { identify }

export default document
